export const LEGACY_REPORTING_URL =
  "https://app.powerbi.com/view?r=eyJrIjoiYWUwMjljMjAtNzk1ZC00Y2UzLWEzMjYtMWEyNTk0MGVkYTQwIiwidCI6ImVlYzdhMTRiLTQ5YmUtNDllZC05NDMxLWI3Y2ViYjYzZTIzOCIsImMiOjl9";
